import { render, staticRenderFns } from "./DashboardGiftcardsCard.vue?vue&type=template&id=5f953e61&"
import script from "./DashboardGiftcardsCard.vue?vue&type=script&lang=js&"
export * from "./DashboardGiftcardsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports